import * as RadioGroup from '@radix-ui/react-radio-group'
import { type RadioGroupItemProps, type RadioGroupProps } from '@radix-ui/react-radio-group'
import { clsx } from 'clsx'
import { type ComponentProps, forwardRef } from 'react'
import { Badge as UIBadge, type BadgeProps as UIBadgeProps } from 'ui/src/components/Badge/Badge'
import { Button as UIButton } from 'ui/src/components/Button/Button'
import { Card } from 'ui/src/components/Card/Card'
import { yStack } from 'ui/src/patterns/stack'
import { item, badge, button } from './CardRadioGroup.css'

function Root({ children, className, ...forwardedProps }: RadioGroupProps) {
  return (
    <RadioGroup.Root className={clsx(yStack({ gap: 'xs' }), className)} {...forwardedProps}>
      {children}
    </RadioGroup.Root>
  )
}

function Item({ children, className, value, ...forwardedProps }: RadioGroupItemProps) {
  return (
    <RadioGroup.Item className={clsx(item, className)} value={value} {...forwardedProps} asChild>
      <Card.Root variant="primary" asChild>
        <button>{children}</button>
      </Card.Root>
    </RadioGroup.Item>
  )
}

function Badge({
  children,
  className,
  isSelected,
  ...forwardedProps
}: Omit<UIBadgeProps, 'color' | 'size'> & { isSelected?: boolean }) {
  return (
    <UIBadge
      className={clsx(badge, className)}
      color={isSelected ? 'signalGreenFill' : 'grayTranslucent25'}
      size="medium"
      {...forwardedProps}
    >
      {children}
    </UIBadge>
  )
}

const Button = forwardRef(function Button(props: ComponentProps<typeof UIButton>, ref: any) {
  const { children, className, ...forwardedProps } = props
  return (
    <UIButton ref={ref} className={clsx(button, className)} {...forwardedProps}>
      {children}
    </UIButton>
  )
})
Button.displayName = 'CardRadioGroup.Button'

export const CardRadioGroup = {
  Root,
  Item,
  Badge,
  Button,
}
